export default "__VITE_ASSET__CFOAn9Ig__"